import { AcademyFrame } from './AcademyFrame';
import { getAcademyDeeplink, getLockedContentDeeplink, isLecoLocked, isLockedContentNavigable } from './academyPath';
import { resolveMobietrainMediaUrl } from './media';
import { clearMobietrainToken } from './token';
import { useFeaturedPath } from './useFeaturedPath';
import { useGetDynamicConfigurationQuery } from './useGetDynamicConfigurationQuery';
import { useMilestones } from './useMilestones';

/**
 * Everything Khova still does through mobietrain: the Academy content and its media,
 * authenticated with the mobietrain SSO token from `POST /academy/token`. Nothing outside
 * `src/integrations/` imports these modules directly: consumers go through the
 * provider-agnostic hooks.
 */
export const mobietrainAdapter = {
  session: {
    clearToken: clearMobietrainToken,
  },
  learning: {
    useDynamicConfiguration: useGetDynamicConfigurationQuery,
    useMilestones,
    useFeaturedPath,
    AcademyFrame,
    getAcademyDeeplink,
    getLockedContentDeeplink,
    isLecoLocked,
    isLockedContentNavigable,
  },
  media: {
    resolveUrl: resolveMobietrainMediaUrl,
  },
  queryKeys: {
    accountUser: ['mobietrain-user'] as const,
  },
};

export type MobietrainAdapter = typeof mobietrainAdapter;
